import { BASE_URL } from "../../configuration/apiconfig";
import UserStore from "../../store/UserStore";
import API from "../../api/api";

export default class PaymentView {
  API_KEY = localStorage.getItem("apiKey");

  paymentStatusCheck = async (paylod) => {
    console.log(paylod);
    return await API.API.post("api_register/payment_success", paylod)
      .then((res) => {
        if (res.status === 204) {
          return {
            status: true,
          };
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };


  RenewpaymentStatusCheck = async (paylod) => {
    console.log(paylod);
    return await API.API.post("profile/payment_success", paylod)
      .then((res) => {
        if (res.status === 204) {
          return {
            status: true,
          };
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };


  StripepaymentStatusCheck = async (paylod) => {
    console.log(paylod);
    return await API.API.post("api_register/stripe_success", paylod)
      .then((res) => {
        if (res.status === 204) {
          return {
            status: true,
          };
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };


  StripepaymentRenewStatusCheck = async (paylod) => {
    console.log(paylod);
    return await API.API.post("profile/stripe_success", paylod)
      .then((res) => {
        if (res.status === 204) {
          return {
            status: true,
          };
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };


}
